import React from 'react';
import cx from 'classnames';
import Spinner from './spinner.jsx';

const CheckboxToggle = ({
  className,
  selected,
  children,
  onChange,
  isPending = false
}) => (
  <label
    aria-busy={isPending}
    className={cx('checkbox-toggle', className, {
      'checkbox-toggle--pending': isPending
    })}
    data-testid={selected ? 'selected-checkbox' : 'checkbox'}
  >
    <input
      checked={selected}
      className="checkbox-toggle__input"
      disabled={isPending}
      onChange={onChange}
      type="checkbox"
    />
    <span className={cx('checkbox-toggle__label', {
      'checkbox-toggle__label--selected': selected
    })}>
      {children}
    </span>
    {isPending && <Spinner className="checkbox-toggle__spinner" color="black" inline />}
  </label>
);

export default CheckboxToggle;
